import React, { createContext, useState, useCallback, useContext } from 'react';

const HeaderContext = createContext({
  isCustomSearchActive: false,
  customSearchPlaceholder: '',
  customSearchHandler: null,
  customActions: null,
  initialValue: '',
  registerSearch: (handler, placeholder, initialValue) => {},
  unregisterSearch: () => {},
  registerActions: actions => {},
  unregisterActions: () => {},
});

export const HeaderProvider = ({ children }) => {
  const [customSearch, setCustomSearch] = useState(null);
  const [customActions, setCustomActions] = useState(null);

  const registerSearch = useCallback((handler, placeholder, initialValue = '') => {
    setCustomSearch({ handler, placeholder, value: initialValue });
  }, []);

  const unregisterSearch = useCallback(() => {
    setCustomSearch(null);
  }, []);

  const registerActions = useCallback(actions => {
    setCustomActions(actions);
  }, []);

  const unregisterActions = useCallback(() => {
    setCustomActions(null);
  }, []);

  const value = {
    isCustomSearchActive: !!customSearch,
    customSearchPlaceholder: customSearch?.placeholder || '',
    customSearchHandler: customSearch?.handler,
    customActions,
    initialValue: customSearch?.value || '',
    registerSearch,
    unregisterSearch,
    registerActions,
    unregisterActions,
  };

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export const useHeader = () => {
  return useContext(HeaderContext);
};

export default HeaderContext;

